import { PagingResultsViewModel, FilterSearchingBaseViewModel, EnumSiNoTodos } from '../../../core/_infrastructure/types/common';

export class SolicitudExItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: SolicitudExItemViewModel[];
}

export class SolicitudExItemViewModel {
    public Id: number;
    public Codigo: string;
    public NumeroCertificado: string;
    public RefSolicitante: string;
    public FechaEnvio: Date | null;
    public HoraEnvio: string;
    public DescripcionTipoSolicitud: string;
    public DescripcionEstadoSolicitud: string;
    public DescripcionIdResultadoEnvioMuestrasLaboratorioEx: string;
    public RazonSocial: string;
    public NombrePuntoInspeccion: string;
    public NombreProvincia: string;
    public NombreCompletoInspector: string;
    public NombreImportador: string;
    public NombrePaisDestino: string;
    public NombreAduana: string;
    public Ubicacion: string;
    public FechaInspeccion: Date | null;
    public HoraInspeccion: string;
    public EsPrevia = false;
    public TieneAlegacion = false;
    public EsEphyto = false;
    public IdEstado: number;
    public IdEstadoCertificadoFitoEx: number;
    public IdResultadoEnvioMuestrasLaboratorioEx: number | null;
    public CodigoTipoSolicitud: string;
    public SolicitudAsignada: number;
    public FormatoSolicitud: string;
    public EsVisibleEdicion: boolean;
    public IdTipoSolicitudEx: number;
    public IdTipoClonacion: number | null;
    public FechaFinalizacion: Date | null;
    public IdSubTipoSolicitudEx: number | null;
    public IdSubTipoSolicitudExDescripcion: string;
    public IdentidadRealizada: string;
    public FisicaRealizada: string;
    public DocumentalRealizada: string;
}

export class FilterSearchingSolicitudExViewModel extends FilterSearchingBaseViewModel {
    firstDayMonth: Date;
    lastDayMonth: Date;

    constructor() {
        super();

        this.firstDayMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        const temp = new Date().getMonth() + 1;
        this.lastDayMonth = new Date(new Date(new Date().getFullYear(), temp, 1).getTime() - 0.001 * 60 * 60 * 24);

        this.FechaDesde = this.firstDayMonth;
        this.FechaHasta = this.lastDayMonth;
    }

    public Codigo = '';
    public NumeroCertificado = '';
    public RefSolicitante = '';
    public IdPuntoInspeccion: number | null;
    public FechaDesde: Date | null;
    public FechaHasta: Date | null;
    public IdTipoSolicitudEx: number | null;
    public IdEstadoSolicitud: number | null;
    public IdEstadoCertificadoFitoEx: number | null;
    public IdProvincia: number | null;
    public IdUsuario = 0;
    public RazonSocial = '';
    //public ApellidosInspector: string = '';
    //public NombreInspector: string = '';
    public NombreExportador = '';
    public IdPaisDestino: number | null;
    public IdResultadoEnvioMuestrasLaboratorioEx: number | null;

    public EsPrevia: number = EnumSiNoTodos.TODOS;
    public TieneAlegacion: number = EnumSiNoTodos.TODOS;
    public EsEphyto: number = EnumSiNoTodos.TODOS;
    public EsPapel: number = EnumSiNoTodos.TODOS;
    public TieneEnvioDeMuestras: number = EnumSiNoTodos.TODOS;
    public EsAtestacionFitosanitaria: number = EnumSiNoTodos.TODOS;
    public AnulaYSustituye: number = EnumSiNoTodos.TODOS;

    public EsInspector: boolean;
    public EsCoordinador: boolean;
    public EsSolicitante: boolean;
    public EsGrabador: boolean;
    public EsComunidadAutonoma: boolean;
    public EsAgenteControl: boolean;
    public IdCaUsuarioCa: number | null;
    public EsConsultas: boolean;
    public EsConsultasySolicitante: boolean;
    public EsConsultasyLaboratorio: boolean;
    public DocumentalRealizada: number = EnumSiNoTodos.TODOS;
}
